import setDataLocal from "../functions/setData";
export default function Option({result_data,opt,setOpt}) {
    let options = ['All','Active','Completed'];
  return (
    <>
        <div className='options'>
        <span>{result_data.Data.reduce((prev,next) => {
            if(!next.complete) {
                prev += 1
            }
            return prev;
        },0)} items left</span>
        <ul className="options_items">
            {options.map((el,index) => <li key={index} className={`${opt == el ? 'active' : ''}`}onClick={_ => setOpt(el)}>{el}</li>)}
        </ul>
        <span className="clear" onClick={_ => {
            let result = result_data.Data.filter(el => !el.complete);
            setDataLocal(false,result);
            result_data.setData(result);
        }}>Clear Completed</span>
    </div>
    <ul className="options_items_2">
            {options.map((el,index) => <li key={index} className={`${opt == el ? 'active' : ''}`}onClick={_ => setOpt(el)}>{el}</li>)}
        </ul>
    </>
  )
}
